import { render, staticRenderFns } from "./SummaryUserData.vue?vue&type=template&id=10680b54&scoped=true&"
import script from "./SummaryUserData.vue?vue&type=script&lang=js&"
export * from "./SummaryUserData.vue?vue&type=script&lang=js&"
import style0 from "./SummaryUserData.vue?vue&type=style&index=0&id=10680b54&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10680b54",
  null
  
)

export default component.exports